import Euro from '../components/svg/Euro';
import EuroTag from '../components/svg/EuroTag';
import Local from '../components/svg/Local';
import Passport from '../components/svg/Passport';
import Shield from '../components/svg/Shield';
import Goodiebag from '../components/svg/Goodiebag';
import Arrangement from '../components/svg/Arrangement';
import Microphone from '../components/svg/Microphone';
import RegioExpert from '../components/svg/RegioExpert';

export const uspIcons = {
    euro: <Euro />,
    tag: <EuroTag />,
    passport: <Passport />,
    shield: <Shield />,
    local: <Local />,
    goodiebag: <Goodiebag />,
    arrangement: <Arrangement />,
    microphone: <Microphone />,
    regioExpert: <RegioExpert />,
};
